module.exports = __webpack_public_path__ + "static/media/star.c2427492.svg";